(function() {
  'use strict';

  /**
   * Prototype to save data to the locally available storage. This uses localforage
   * as backend to always get the most adequate storage backend that the browser
   * supports. We're using callbacks since this code will be called from both footer.js
   * and Angular to have a common API interface. As of now, we can't make guarantee
   * that the promise version will work all the time in all browsers (IE 11 is a problem)
   * and therefore we use the callback fallback as standard. In the future this can
   * be re-written to use the promise based calls that localforage provides.
   */
  var SBCStorage = function () {}

  /**
   * SESSION_NOT_SUPPORTED indicates whether the current browser supports
   * sessionStorage or not
   *
   * @type {Boolean}
   */
  SBCStorage.prototype.SESSION_NOT_SUPPORTED = false;

  /**
   * Sets up the session in case sessionStorage is supported and we don't have
   * an active session yet.
   *
   * @param  {Function} callback Callback to call after setting up the session
   * @return {void}
   */
  SBCStorage.prototype.setupSession = function (callback) {
    if ("sessionStorage" in window && isSessionStorageSupported()) {
      var existingInfo = JSON.parse(window.sessionStorage.getItem('sbcSession'));
      var isSession = existingInfo && existingInfo.session;

      if (isSession) {
        callback(isSession);
      } else {
        // There is no session, we need to initiate it
        this.setSessionInfo(callback);
      }
    } else {
      callback(this.SESSION_NOT_SUPPORTED);
    }
  };

  /**
   * Write the sessionInfo (session boolean and timestamp) to the sessionStorage
   * to make sure that we only cache in IndexedDB per session. This means that after
   * restarting the browser the data will always be fetched and IndexedDB will be
   * re-initialized.
   *
   * @param  {Function} callback Callback to call after setting up the session
   * @return {void}
   */
  SBCStorage.prototype.setSessionInfo = function (callback) {
    var existingInfo = JSON.parse(window.sessionStorage.getItem('sbcSession'));

    if (!existingInfo || !existingInfo.session) {
      var sessionItem = {
        session: true,
        created: new Date()
      };

      window.sessionStorage.setItem('sbcSession', JSON.stringify(sessionItem));

      // We also need to clean the IndexedDB to make sure it's fresh for the new session
      this.cleanStorage(function () {
        callback(sessionItem);
      });
    } else {
      callback(existingInfo);
    }
  };

  /**
   * Gets an item from the IndexedDB store.
   *
   * @param  {String}   key       Key identifying the item to get from the local storage
   * @param  {Function} callback  Callback to call after getting the item
   * @return {void}
   */
  SBCStorage.prototype.getItem = function (key, callback) {
    localforage.getItem(key, callback);
  };

  /**
   * Sets an item from the IndexedDB store. Since saving the item to the storage is not
   * an operation we need to block on, the callback will be undefined in most cases.
   *
   * @param  {String}   key       Key identifying the item to set from the local storage
   * @param  {Object}   value     Object to write to the storage
   * @param  {Function} callback  Callback to call after setting the item
   * @return {void}
   */
  SBCStorage.prototype.setItem = function (key, value, callback) {
    localforage.setItem(key, value, callback);
  };

  /**
   * Clears the storage to make sure there is no old data.
   *
   * @param  {Function} callback  Callback to call after clearing the storage
   * @return {void}
   */
  SBCStorage.prototype.cleanStorage = function (callback) {
    localforage.clear(callback);
  };

  /**
   * Returns a given entry from the sessionStorage
   *
   * @param  {String}   key      key to search for
   * @param  {Function} callback Callback to call after setting up the session
   * @return {Object}
   */
  SBCStorage.prototype.getSessionItem = function (key) {
    return JSON.parse(window.sessionStorage.getItem(key));
  };

  /**
   * Write a given key value pair to the sessionStorage
   *
   * @param  {String}   key      key to write to
   * @param  {Object}   key      object to write
   * @return {Object}
   */
  SBCStorage.prototype.setSessionItem = function (key, value) {
    var existingItem = JSON.parse(window.sessionStorage.getItem(key));

    if (!existingItem || existingItem != value) {
      window.sessionStorage.setItem(key, JSON.stringify(value));

      return value;
    } else {
      return existingItem;
    }
  };

  /**
   * Removes a given key from the sessionStorage
   *
   * @param  {String}   key      key to remove
   * @return {void}
   */
  SBCStorage.prototype.removeSessionItem = function (key) {
    window.sessionStorage.removeItem(key);
  };

  /**
   * Checks weather or not the session storage can be uesd nedds to be wrapped in a try catch
   * due to safari incognito mode has session storage object but does not allow to store items in it.
   *
   * @returns {boolean}
   */
  function isSessionStorageSupported() {
    var testKey = 'isSessionStorageSupported';
    var storage = window.sessionStorage;
    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };


  window.SBCStorage = new SBCStorage();
})();
